var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dinlineb" },
    [
      !_vm.hasAccess
        ? _c(
            "el-tooltip",
            {
              attrs: { placement: "top" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "content",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Vous n'avez pas les permissions nécessaires pour effectuer cette action."
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                4007582992
              )
            },
            [
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link pointer",
                  class: !_vm.hasAccess ? "link-disabled" : ""
                },
                [_vm._t("default")],
                2
              )
            ]
          )
        : _c(
            "a",
            { staticClass: "link pointer", on: { click: _vm.clicked } },
            [_vm._t("default")],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }